module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Partner',
          to: {
            path: '/partnership-member'
          }
        },
        {
          text: 'Detail Partner'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Detail Partner")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n            Detail Profile "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isLoading) ? _c('v-card-text', {
    staticClass: "px-5 pt-5"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "card",
      "height": "320",
      "width": "100%"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('v-card-text', [_c('div', {
    staticClass: "mt-5"
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', {
          staticStyle: {
            "background-color": "#f7f6f3"
          }
        }, [_c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v("Tanggal Dibuat")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.tanggal_buat) + "6 Desember 2023\n                                ")])])])]
      },
      proxy: true
    }], null, false, 63391912)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-8"
  }, [_c('div', [_c('h4', {
    staticClass: "font-weight-bold mb-4 ml-4"
  }, [_vm._v("\n                        Detail Profil Partner\n                    ")])]), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v("Nama Partner")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.data.nama))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Provinsi")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.partner_provinsi.nama_provinsi) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kota/Kabupaten")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.partner_kabupaten_kota
          .nama_kabupaten_kota) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kecamatan")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.partner_kecamatan
          .nama_kecamatan) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kelurahan")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.partner_kelurahan
          .nama_kelurahan_desa) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Alamat Lengkap Sekolah")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.alamat) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nomor Telepon")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.no_telp) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kepala Sekolah")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.nama_kepsek || "-") + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Surat Kesepakatan")]), _vm._v(" "), _c('td', {
          staticClass: "py-2"
        }, [_vm._l((_vm.document), function(doc, index) {
          return _c('v-btn', {
            key: index,
            staticClass: "mr-2 my-1 py-4",
            staticStyle: {
              "color": "#26a69a"
            },
            attrs: {
              "depressed": "",
              "dark": "",
              "small": "",
              "color": "#E0F2F1"
            },
            on: {
              "click": function($event) {
                return _vm.openDocument(doc)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "20px",
              "margin-right": "5px"
            }
          }, [_vm._v("\n                                            mdi-file-outline\n                                        ")]), _vm._v("\n\n                                        " + _vm._s(doc.data_name) + "\n                                    ")], 1)
        }), _vm._v(" "), (!_vm.document.length) ? _c('span', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n                                        Belum ada surat kesepakatan\n                                    ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', {
          staticClass: "py-3"
        }, [(_vm.data.status === 'WAITING') ? _c('div', [_c('v-btn', {
          attrs: {
            "depressed": "",
            "color": "primary",
            "disabled": !_vm.document.length ||
              !_vm.list_program.length
          },
          on: {
            "click": function($event) {
              return _vm.confirmApprove('APPROVE')
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          staticStyle: {
            "font-size": "20px"
          }
        }, [_vm._v("\n                                                mdi-check\n                                            ")]), _vm._v("\n                                            Setujui\n                                        ")], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ml-2",
          attrs: {
            "depressed": "",
            "dark": "",
            "color": "#FF4D4D"
          },
          on: {
            "click": function($event) {
              return _vm.confirmApprove('REJECT')
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          staticStyle: {
            "font-size": "20px"
          }
        }, [_vm._v("\n                                                mdi-close\n                                            ")]), _vm._v("\n                                            Tolak\n                                        ")], 1)], 1) : _c('div', [(_vm.data.status === 'WAITING') ? _c('v-btn', {
          staticStyle: {
            "color": "#2690cb"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E8F5FA"
          }
        }, [_vm._v("\n                                            Belum Disetujui\n                                        ")]) : _vm._e(), _vm._v(" "), (_vm.data.status === null) ? _c('v-btn', {
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFF3E0"
          }
        }, [_vm._v("\n                                            Draft\n                                        ")]) : _vm._e(), _vm._v(" "), (_vm.data.status === 'REJECT') ? _c('v-btn', {
          staticStyle: {
            "color": "#ec675e"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFE5E5"
          }
        }, [_vm._v("\n                                            Ditolak\n                                        ")]) : _vm._e(), _vm._v(" "), (_vm.data.status === 'APPROVE') ? _c('v-btn', {
          staticStyle: {
            "color": "#40bf75"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#EEFFE0"
          }
        }, [_vm._v("\n                                            Disetujui\n                                        ")]) : _vm._e(), _vm._v(" "), (
          _vm.data.status === 'REGISTER'
        ) ? _c('v-btn', {
          staticStyle: {
            "color": "#26a69a"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E0F2F1"
          }
        }, [_vm._v("\n                                            Baru\n                                        ")]) : _vm._e()], 1)])])])]
      },
      proxy: true
    }], null, false, 2853330643)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-10 mb-5"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold mb-4 ml-4"
  }, [_vm._v("\n                                Detail Program\n                            ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right pr-8"
  }, [_c('v-btn', {
    staticClass: "pa-3 ml-2",
    staticStyle: {
      "color": "#039be5"
    },
    attrs: {
      "depressed": "",
      "rouded": "",
      "small": "",
      "height": "33px",
      "color": "#E1F5FE",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog_program = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n                                    mdi-plus\n                                ")]), _vm._v("\n                                Tambah Program\n                            ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_c('b', [_vm._v("Nama Program")])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_c('b', [_vm._v("Pemilik Program")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Deskripsi")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.list_program), function(row, index) {
          return [_c('tr', [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.data_owner.nama || "-") + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.description) + "\n                                    ")])])]
        }), _vm._v(" "), (!_vm.list_program.length) ? [_c('tr', {
          staticStyle: {
            "background-color": "#f7f6f3"
          }
        }, [_c('td', {
          attrs: {
            "colspan": "3",
            "align": "center"
          }
        }, [_vm._v("\n                                        Belum ada program\n                                    ")])])] : _vm._e()], 2)]
      },
      proxy: true
    }], null, false, 2060460143)
  })], 1), _vm._v(" "), (_vm.data.data_pic) ? _c('div', {
    staticClass: "mt-10 mb-5"
  }, [_c('div', [_c('h4', {
    staticClass: "font-weight-bold mb-4 ml-4"
  }, [_vm._v("\n                        Detail Profil Penanggung Jawab\n                    ")])]), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_vm._l((_vm.data.data_pic), function(row, index) {
          return [_c('tr', [_c('td', {
            attrs: {
              "width": "20%"
            }
          }, [_vm._v("\n                                        Nama PIC " + _vm._s(index + 1) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.nama) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nomor Telepon")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.noTelp) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.email) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jabatan")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(row.jabatan) + "\n                                    ")])])]
        })], 2)]
      },
      proxy: true
    }], null, false, 2324391252)
  })], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.confirm_approve) ? _c('v-dialog', {
    attrs: {
      "max-width": "370"
    },
    model: {
      value: (_vm.confirm_approve),
      callback: function($$v) {
        _vm.confirm_approve = $$v
      },
      expression: "confirm_approve"
    }
  }, [
    [_c('v-card', [_c('v-card-title', {
      staticStyle: {
        "word-break": "break-word !important"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.approval_title) + "\n                ")]), _vm._v(" "), _c('v-card-actions', {
      staticClass: "pb-5"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "blew",
        "dark": "",
        "depressed": "",
        "loading": _vm.loading_approve
      },
      on: {
        "click": function($event) {
          return _vm.sendProcessPartner()
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.approval_status === "APPROVE" ?
      "Setuju" :
      "Tolak") + "\n                    ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "darkFade",
        "text": ""
      },
      on: {
        "click": function($event) {
          _vm.confirm_approve = false
        }
      }
    }, [_vm._v("\n                        Batal\n                    ")])], 1)], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.dialog_program) ? _c('v-dialog', {
    attrs: {
      "max-width": "1000",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog_program),
      callback: function($$v) {
        _vm.dialog_program = $$v
      },
      expression: "dialog_program"
    }
  }, [
    [_c('v-card', [_c('v-toolbar', {
      attrs: {
        "dark": "",
        "color": "#0277BD"
      }
    }, [_c('v-toolbar-title', [_vm._v("\n                        Daftar Partnership Program\n                    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "mr-1",
      attrs: {
        "icon": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.dialog_program = false
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('partnership-program', {
      on: {
        "selectedRow": function($event) {
          return _vm.selectedRowProgram($event)
        }
      }
    })], 1)], 1)]
  ], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205d8553","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/partnership/components/PartnershipMemberDetail.vue
// module id = 2205
// module chunks = 1